(ns client-portal.client.drive-thru.locations.individual.data
  (:require [shared.core.reactive :as re]
            [shared.core.util :as util]
            [shared.core.router :as router]))

(def locations-path [:drive-thru :locations :individual])
(def locations-manage-path (conj locations-path :manage))
(def location-volume-path (conj locations-manage-path :volume-form))
(def location-ngrok-path (conj locations-manage-path :ngrok-form))
(def location-external-doc-path (conj locations-manage-path :external-doc-form))
(def location-hardware-path (conj locations-manage-path :external-hardware-form))
(def location-sip-path (conj locations-manage-path :external-sip-form))
(def location-network-path (conj locations-manage-path :external-network-form))

(defn merge-preferring-non-null [m1 m2]
  "Merges two maps, preferring non-null values from m1 over m2."
  (merge-with (fn [v1 v2]
                (if (nil? v1) v2 v1)) m1 m2))

(re/reg-event-db
 :locations/manage-volume re/middleware
 (fn [db [volume mac-address]]
   (re/dispatch [:modals/show [:locations/manage-volume-modal (merge volume {:mac-address mac-address})]])
   (assoc-in db location-volume-path volume)
   db
   ))

(defn location-manage-volume [db]
  (get-in db location-volume-path))

(re/reg-sub :locations/manage-volume- location-manage-volume)

(re/auth0-http-request
  :locations/manage-volume-save
  location-volume-path
  (fn [db args]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)
          {:keys [mac-address]} args
          merged-map (merge-preferring-non-null (location-manage-volume db) args)
          {:keys [volume-lane-speaker volume-lane-microphone volume-headset-speaker volume-headset-microphone volume-ai-speaker mac-address]} merged-map]
      {:method :post
       :json-params {:concept-id (util/parse-int concept-id)
                     :location-id (util/parse-int location-id)
                     :volume-lane-speaker volume-lane-speaker
                     :volume-lane-microphone volume-lane-microphone 
                     :volume-headset-speaker volume-headset-speaker 
                     :volume-headset-microphone volume-headset-microphone
                     :volume-ai-speaker volume-ai-speaker
                     :mac-address mac-address}
       :url "/api/drive-thru/volume"}))
  :on-success (fn [db [resp] {:keys [event-args]}]
                (println "success dispatch")
                (re/dispatch [:modals/hide])
                (re/dispatch [:drive-thru/load-location-by-current-route-concept-id-location-id])
                db)
  :on-fail (fn [db arg1 arg2]
             (println "fail")
             db))

(re/reg-event-db
 :locations/manage-ngrok re/middleware
 (fn [db [data mac-address]]
   (re/dispatch [:modals/show [:locations/manage-ngrok-modal (merge data {:mac-address mac-address})]])
   (assoc-in db location-volume-path data)
   db
   ))

(defn location-manage-ngrok [db]
  (get-in db location-ngrok-path))

(re/reg-sub :locations/manage-ngrok- location-manage-ngrok)

(re/auth0-http-request
  :locations/manage-ngrok-save
  location-ngrok-path
  (fn [db args]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)
          {:keys [mac-address]} args
          merged-map (merge-preferring-non-null (location-manage-ngrok db) args)
          {:keys [ngrok-http-ip-address ngrok-http-port ngrok-ssh-ip-address ngrok-ssh-port mac-address]} merged-map]
      {:method :post
       :json-params {:concept-id (util/parse-int concept-id)
                     :location-id (util/parse-int location-id)
                     :ngrok-http-ip-address ngrok-http-ip-address
                     :ngrok-http-port ngrok-http-port
                     :ngrok-ssh-ip-address ngrok-ssh-ip-address
                     :ngrok-ssh-port ngrok-ssh-port
                     :mac-address mac-address}
       :url "/api/drive-thru/ngrok"}))
  :on-success (fn [db [resp] {:keys [event-args]}]
                (println "success dispatch")
                (re/dispatch [:modals/hide])
                (re/dispatch [:drive-thru/load-location-by-current-route-concept-id-location-id])
                db)
  :on-fail (fn [db arg1 arg2]
             (println "fail")
             db))

(re/reg-event-db
 :locations/manage-external-doc re/middleware
 (fn [db [data]]
   (re/dispatch [:modals/show [:locations/manage-external-doc-modal data]])
   (assoc-in db location-external-doc-path data)
   db
   ))

(defn location-manage-external-doc [db]
  (get-in db location-external-doc-path))

(re/reg-sub :locations/manage-external-doc- location-manage-external-doc)

(re/auth0-http-request
  :locations/manage-external-doc-save
  location-external-doc-path
  (fn [db args]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)
          merged-map (merge-preferring-non-null (location-manage-external-doc db) args)
          {:keys [external-documentation-folder]} merged-map]
      {:method :post
       :json-params {:concept-id (util/parse-int concept-id)
                     :location-id (util/parse-int location-id)
                     :external-documentation-folder external-documentation-folder}
       :url "/api/drive-thru/external-doc"}))
  :on-success (fn [db [resp] {:keys [event-args]}]
                (println "success dispatch")
                (re/dispatch [:modals/hide])
                (re/dispatch [:drive-thru/load-location-by-current-route-concept-id-location-id])
                db)
  :on-fail (fn [db arg1 arg2]
             (println "fail")
             db))

(re/reg-event-db
 :locations/manage-hardware re/middleware
 (fn [db [data mac-address]]
   (re/dispatch [:modals/show [:locations/manage-hardware-modal (merge data {:mac-address mac-address})]])
   (assoc-in db location-hardware-path data)
   db
   ))

(defn location-manage-hardware [db]
  (get-in db location-hardware-path))

(re/reg-sub :locations/manage-hardware- location-manage-hardware)

(re/auth0-http-request
  :locations/manage-hardware-save
  location-hardware-path
  (fn [db args]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)
          {:keys [mac-address]} args
          merged-map (merge-preferring-non-null (location-manage-hardware db) args)
          {:keys [software-version codec lane-microphone-type echo-cancel-type aggressiveness extra-noise-reduction echo-tail mac-address]} merged-map]
      {:method :post
       :json-params {:concept-id (util/parse-int concept-id)
                     :location-id (util/parse-int location-id)
                     :software-version software-version
                     :codec codec
                     :lane-microphone-type lane-microphone-type
                     :echo-cancel-type echo-cancel-type
                     :aggressiveness aggressiveness
                     :extra-noise-reduction extra-noise-reduction
                     :echo-tail echo-tail
                     :mac-address mac-address}
       :url "/api/drive-thru/hardware"}))
  :on-success (fn [db [resp] {:keys [event-args]}]
                (println "success dispatch")
                (re/dispatch [:modals/hide])
                (re/dispatch [:drive-thru/load-location-by-current-route-concept-id-location-id])
                db)
  :on-fail (fn [db arg1 arg2]
             (println "fail")
             db))


(re/reg-event-db
 :locations/manage-sip re/middleware
 (fn [db [data mac-address]]
   (re/dispatch [:modals/show [:locations/manage-sip-modal (merge data {:mac-address mac-address})]])
   (assoc-in db location-sip-path data)
   db
   ))

(defn location-manage-sip [db]
  (get-in db location-sip-path))

(re/reg-sub :locations/manage-sip- location-manage-sip)

(re/auth0-http-request
  :locations/manage-sip-save
  location-sip-path
  (fn [db args]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)
          {:keys [mac-address]} args
          merged-map (merge-preferring-non-null (location-manage-sip db) args)
          {:keys [sip-username sip-password sip-transport-type sip-server-address sip-outdial-number sip-from-header-replacement mac-address]} merged-map]
      {:method :post
       :json-params {:concept-id (util/parse-int concept-id)
                     :location-id (util/parse-int location-id)
                     :sip-username sip-username
                     :sip-password sip-password
                     :sip-transport-type sip-transport-type
                     :sip-server-address sip-server-address
                     :sip-outdial-number sip-outdial-number
                     :sip-from-header-replacement sip-from-header-replacement
                     :mac-address mac-address}
       :url "/api/drive-thru/sip"}))
  :on-success (fn [db [resp] {:keys [event-args]}]
                (println "success dispatch")
                (re/dispatch [:modals/hide])
                (re/dispatch [:drive-thru/load-location-by-current-route-concept-id-location-id])
                db)
  :on-fail (fn [db arg1 arg2]
             (println "fail")
             db))

(re/reg-event-db
 :locations/manage-network re/middleware
 (fn [db [data mac-address]]
   (re/dispatch [:modals/show [:locations/manage-network-modal (merge data {:mac-address mac-address})]])
   (assoc-in db location-network-path data)
   db
   ))

(defn location-manage-network [db]
  (get-in db location-network-path))

(re/reg-sub :locations/manage-network- location-manage-network)

(re/auth0-http-request
  :locations/manage-network-save
  location-network-path
  (fn [db args]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)
          {:keys [mac-address]} args
          merged-map (merge-preferring-non-null (location-manage-network db) args)
          {:keys [ip-address subnet-mask gateway dns-1 dns-2 switch-model switch-port-range mac-address]} merged-map]
      {:method :post
       :json-params {:concept-id (util/parse-int concept-id)
                     :location-id (util/parse-int location-id)
                     :ip-address ip-address
                     :subnet-mask subnet-mask
                     :gateway gateway
                     :dns-1 dns-1
                     :dns-2 dns-2
                     :switch-model switch-model
                     :switch-port-range switch-port-range
                     :mac-address mac-address}
       :url "/api/drive-thru/network"}))
  :on-success (fn [db [resp] {:keys [event-args]}]
                (println "success dispatch")
                (re/dispatch [:modals/hide])
                (re/dispatch [:drive-thru/load-location-by-current-route-concept-id-location-id])
                db)
  :on-fail (fn [db arg1 arg2]
             (println "fail")
             db))



